import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem, Select } from '@/core/ui';
import { useController } from 'react-hook-form';
import { t } from '@/core/localization';
import { PaymentDelayDayType } from '@/shared/models';
const PaymentDelayDayTypeSelect = ({ control, name }) => {
    const { field } = useController({ control, name });
    return (_jsxs(Select, { ...field, children: [_jsx(MenuItem, { value: PaymentDelayDayType.Calendar, children: t('day.type.calendar') }), _jsx(MenuItem, { value: PaymentDelayDayType.Working, children: t('day.type.working') })] }));
};
export { PaymentDelayDayTypeSelect };
